<script>
  /* Les composants et packages dont on a besoin */
  // Importing Line class from the vue-chartjs wrapper
  import { Line } from 'vue-chartjs'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'LineChartsjsTemplate',

    /* Autre composant utilisé comme base de travail */
    extends: Line,

    /* Paramètres */
    props: {
      datacollection: Object,
      options: Object,
    },

    /* Variables surveillées : traitement si modification de sa valeur */
    watch: {
      datacollection: function () {
        this.renderMethod()
      },
      options: function () {
        this.renderMethod()
      },
    },

    /* Hook : fonction appelée juste après que l’instance ait été montée */
    mounted () {
      this.renderMethod()
    },

    /* Fonctions internes */
    methods: {
      renderMethod: function () {
        if (this.datacollection && this.options) {
          // renderChart génère le graphique à partir des données et des options
          this.renderChart(this.datacollection, this.options)
        }
      },
    },

  }
</script>
